module.exports = __webpack_public_path__ + "static/9-655d8a12d1b05d14ecf5b5931545a630.wav";